const UiLockActions = {
    SHOW_ACTION: 'SHOW_ACTION',
    HIDE_ACTION: 'HIDE_ACTION',
};

export { UiLockActions };